import Loadable from 'my-components/Loadable';

// export default Loadable(() => import(/* webpackChunkName: "essay-writer" */ './TemplateEditor'));
export default Loadable(() => import(/* webpackChunkName: "essay-writer" */ './EssayJackRouter'));

export const LandingPage = Loadable(() => import(/* webpackChunkName: "essay-writer-landing" */ './LandingPage'));
